import type { SelectionListContextState } from './SelectionListProvider';
import type { GqlSelectionListKey, SelectionListState } from './types';

type SetSelectionListsAction = {
  type: 'SET_SELECTION_LISTS';
  payload: SelectionListState<GqlSelectionListKey>;
};

type MergeSelectionListsAction = {
  type: 'MERGE_SELECTION_LISTS';
  payload: Partial<SelectionListState<GqlSelectionListKey>>;
};

export type SelectionListAction =
  | SetSelectionListsAction
  | MergeSelectionListsAction;

export const selectionListReducer = (
  state: SelectionListContextState,
  action: SelectionListAction
) => {
  switch (action.type) {
    case 'SET_SELECTION_LISTS':
      return {
        ...state,
        selectionLists: action.payload,
      };

    case 'MERGE_SELECTION_LISTS':
      return {
        ...state,
        selectionLists: {
          ...state.selectionLists,
          ...action.payload,
        },
      };

    default:
      return state;
  }
};
